// Single source for GCSB Academic Credits (GCSB-STD-004 clause 3). Not assessment weights or CPD hours.
export const GCSB_CREDITS = { CSCE: 15, CSP: 20, CSL: 20, CCSO: 20, EIP: 15, PGDCSL: 90 };
export const CREDIT_UNIT = "GCSB Academic Credits";

const base = (code) => (code || "").replace(/-(EXAM|DIRECT)$/, "");
export const creditsFor = (code) => GCSB_CREDITS[base(code)];
export const creditLabel = (codeOrNumber) => {
  const n = typeof codeOrNumber === "number" ? codeOrNumber : creditsFor(codeOrNumber);
  return n ? `${n} ${CREDIT_UNIT}` : "";
};
